import { graphql } from "@opensea/graphql"
import { getMediaPropsFromMediaFragment } from "@/components/collection/overview/utils"

export const PreviewImageFragment = graphql(
  `
    fragment PreviewImage on Media {
      ...MediaProps
    }
  `,
  [getMediaPropsFromMediaFragment],
)
